import _ from 'underscore';
import { Router } from '@bingads-webui/router';

import NotificationReady from './notification-ready';
import { AdCenterPage } from './constants';

// Based on the rules in private\UI\Platform\Framework\Controls\Web\Repositories\RootRepository.cs
export function isOnCampaignsPage(pathname = window.location.pathname) {
  return pathname.toLowerCase().indexOf('/campaign/vnext/campaigns') === 0;
}

export function isOnAdsPage(pathname = window.location.pathname) {
  return pathname.toLowerCase().indexOf('/campaign/vnext/ads') === 0;
}

export function isOnKeywordsPage(pathname = window.location.pathname) {
  return pathname.toLowerCase().indexOf('/campaign/vnext/keywords') === 0;
}

export function isOnAccountsSummaryPage(pathname = window.location.pathname) {
  return pathname.toLowerCase().indexOf('/campaign/accountssummary') === 0;
}

export function isOnClientCenterPage(pathname = window.location.pathname) {
  return pathname.toLowerCase().indexOf('/cc') === 0;
}

export function isOnOpportunityPage(
  pathname = window.location.pathname,
  hash = window.location.hash
) {
  return pathname.toLowerCase().indexOf('/opportunity') === 0 ||
  (isOnCampaignsPage(pathname) && hash.toLowerCase().indexOf('/recommendations') > 0);
}

const getAdCenterPageEnum = (pathname = window.location.pathname) => {
  if (isOnCampaignsPage(pathname)) {
    return AdCenterPage.Campaign;
  }
  if (isOnAdsPage(pathname)) {
    return AdCenterPage.Ads;
  }
  if (isOnKeywordsPage(pathname)) {
    return AdCenterPage.Keyword;
  }

  return AdCenterPage.Default;
};

const extendRes = (res, key, str, pattern, setMismatchToNull = false) => {
  const matches = str.match(pattern);

  // When setMismatchToNull is true, if id in url hash and query is not matching, set it to null
  // UNQ request won't be sent if !!cid === false
  if (matches && matches[1]) {
    _.extend(res, { [key]: setMismatchToNull && matches[1] !== res[key] ? null : matches[1] });
  }
};

const extendResWithCid = (res, hash) => extendRes(res, 'cid', hash, /#customer\/(\d+)\//, true);
const extendResWithAid = (res, hash) => extendRes(res, 'aid', hash, /\/account\/(\d+)\//);
const extendResWithCampaignId = (res, hash) => extendRes(res, 'campaignId', hash, /\/campaign\/(\d+)\//);

const getParametersInUrl = (
  href = window.location.href,
  hash = window.location.hash,
  pathname = window.location.pathname
) => {
  let res = {};

  if (isOnClientCenterPage(pathname) && !_.isEmpty(hash)) {
    res = Router.parseHash(hash).properties;

    // There are some pages in CCUI that no query is in hash, so only if
    // cid is in hash query we can consider the res is useful.
    if (_.has(res, 'cid')) {
      return res;
    }
  }

  res = Router.parsePathAndQuery(href).properties;

  // only need cid for Accounts Summary page
  if (isOnAccountsSummaryPage(pathname)) {
    res = { cid: res.cid };
    extendResWithCid(res, hash);
    return res;
  }

  // override res with the ids in hash on Campaigns page
  if (isOnCampaignsPage(pathname)) {
    extendResWithCid(res, hash);
    extendResWithAid(res, hash);
    extendResWithCampaignId(res, hash);
  }

  return res;
};

export function getParameters(
  href = window.location.href,
  hash = window.location.hash,
  pathname = window.location.pathname
) {
  return {
    ...getParametersInUrl(href, hash, pathname),
    pageEnum: getAdCenterPageEnum(pathname),
  };
}

export const notificationReady = new NotificationReady();
